import Table, { TableRow } from "../../../../../common/components/molecule/Table/Table";

export interface ChargePointItem {
    name?: string;
    hardwareIDRender?:  () => JSX.Element;
    id : string;
    onClick?: () => void;
    nbConnector?: () => JSX.Element;
    ActionBtnRender?: () => JSX.Element;
}

export interface ChargePointListViewProps {
    content?: ChargePointItem[];
}


export default function ChargePointListView({content} : ChargePointListViewProps) {
const formatedContent : TableRow[] = content?.map((chargePoint) => ({
    id: chargePoint.id,
    data: [
        chargePoint.name|| "N/A",
        chargePoint.hardwareIDRender || "N/A",
        () => chargePoint.nbConnector?.() || <></>,
        chargePoint.ActionBtnRender
    ],
    onRowClick: chargePoint.onClick,
})) || []
    
  return (
    <div>
      <Table
        headerTitle={[
          "Nom",
          "Device ID",
          "Nb Connecteur",
        ]}
        bodyData={formatedContent }
        emptyMessage="Aucune borne trouvée"
      />
    </div>
  )
}
